import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import { requestApiData, getAffiliateUserType } from '../../../Actions/actions';
import whiteLogo from '../../../images/white-logo.png';
import bannerImg from '../../../images/banner-img.png';
import dashImg1 from '../../../images/dash-img1.png';
import TextFieldGroup from '../../common/TextFieldGroup';


class LandingPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      affiliateType: '',
      userId: '',
      email: '',
      errors: {},
    };
    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  componentWillUnmount() {
  }

  componentWillMount() {
    this.setState({
      userId: this.props.partnerType,
      affiliateType: this.props.affiliateId,
    });
  }


  render() {
    const {
      affiliateType, userId, email, errors,
    } = this.state;
    const link = `/signup/${affiliateType}/${userId}/${email}`;
    return (
      <div>
        <header className="section landing-hdr-partner">
          <div className="row">
            <div className="col s12">
              <div className="logo logo-dash">
                <a href="" onClick={e => e.preventDefault()}>
                  <img className="responsive-img" src={whiteLogo} alt="" />
                </a>
              </div>
            </div>
            <div className="col s12 m6">
              <h1>Class Action Settlements Simplified..</h1>
            </div>
            <div className="col s12 m6">
              <div className="banner-img">
                <img className="responsive-img" src={bannerImg} alt="" />
              </div>
            </div>
          </div>
        </header>
        <div className="container">
          <div className="section-content landing-settlement">
            <div className="row">
              <div className="col s12">
                <div className="landing-blue-box">
                  <h4>ReddyIce Settlement / $30m</h4>
                </div>
              </div>

              <div className="col s10 offset-s1">
                <div className="landing-data">
                  <div className="data-section">
                    <div className="col s12 m3 l2">
                      <div className="green-box">
                        <img src={dashImg1} alt="" />
                      </div>
                    </div>
                    <div className="col s12 m9 l10">
                      <div className="landing-data-hdr">
                        <h5>
ReddyIce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                        <a
                          className="featured waves-effect waves-light btn"
                          href=""
                          onClick={e => e.preventDefault()}
                        >
                          <i
                            className="small material-icons"
                          >
star

                          </i>
                          {' '}
Featured

                        </a>
                      </div>
                      <div className="landing-data-bot">
                        <a href="" onClick={e => e.preventDefault()}>Overview</a>
                        <p>
Nullam dapibus magna vel elit pharetra, quis consectetur ex eleifend.
                                                    Donec in urna varius,
                                                    varius nunc sed, lobortis augue. Phasellus tristique ac ligula nec
                                                    vestibulum.

                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="data-section">
                    <div className="col s12 m3 l2">
                      <div className="green-box">
                        <img src={dashImg1} alt="" />
                      </div>
                    </div>
                    <div className="col s12 m9 l10">
                      <div className="landing-data-hdr">
                        <h5>
ReddyIce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                      </div>
                      <div className="landing-data-bot">
                        <a href="" onClick={e => e.preventDefault()}>Overview</a>
                        <p>
Nullam dapibus magna vel elit pharetra, quis consectetur ex eleifend.
                                                    Donec in urna varius,
                                                    varius nunc sed, lobortis augue. Phasellus tristique ac ligula nec
                                                    vestibulum.

                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="data-section">
                    <div className="col s12 m3 l2">
                      <div className="green-box">
                        <img src={dashImg1} alt="" />
                      </div>
                    </div>
                    <div className="col s12 m9 l10">
                      <div className="landing-data-hdr">
                        <h5>
ReddyIce Settlement
                          {' '}
                          <span>/</span>
                          {' '}
$30m
                        </h5>
                      </div>
                      <div className="landing-data-bot">
                        <a href="" onClick={e => e.preventDefault()}>Overview</a>
                        <p>
Nullam dapibus magna vel elit pharetra, quis consectetur ex eleifend.
                                                    Donec in urna varius,
                                                    varius nunc sed, lobortis augue. Phasellus tristique ac ligula nec
                                                    vestibulum.

                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="landing-email">
                  <div className="row">
                    <div className="col s12 m8">
                      <div className="input-field">
                        <TextFieldGroup
                          field="email"
                          label="Email"
                          value={email}
                          error={errors.email}
                          onChange={this.onChange}
                        />

                      </div>

                    </div>
                    <div className="col s12 m4">
                      <Link to={link} className="waves-effect waves-light btn">Enroll Now</Link>
                    </div>
                  </div>
                </div>
              </div>

            </div>


          </div>


        </div>
      </div>
    );
  }
}

LandingPage.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ requestApiData, getAffiliateUserType }, dispatch);

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(LandingPage));
